import { EXERCISE_CLASS_NAME } from 'modules/training/models/exercise/constants'

const REDUX_NON_DIRECTLY_SAVABLE = [
  EXERCISE_CLASS_NAME
]

export default REDUX_NON_DIRECTLY_SAVABLE
